export const environment = {
  production: true,
  envName: 'uat',
  apiUrl: 'https://api-uatdcssportal.ga.gov',
  sitUrl: 'https://api-testdcssportal.ga.gov',
  devUrl: 'https://api-devdcssportal.ga.gov',
  uatUrl: 'https://api-uatdcssportal.ga.gov',
  prodUrl: 'https://api-dcssportal.ga.gov',
  developmentUrl: 'http://localhost:9001',
  paymentUrl: 'https://ga.smartchildsupport.com/TestUat/Mobile',
  dcssPublicApiToken: "q=I'(jZK6KcZG]!'EH1D8[NQFno$-w_vB)+62%h7,vx+NT0^&>",
  recaptcha: {
    stks: '',
    webks: '',
    androidks: '',
    iosks: '',
  },
};